import { useState } from 'react';

export default function Plans() {
  const [selectedCarrier, setSelectedCarrier] = useState('中華電信');

  const carriers = ['中華電信', '台灣大哥大', '遠傳電信'];

  const plans = {
    '中華電信': [
      { 
        name: 'NT$ 599', 
        price: 'NT$ 599', 
        features: [
          '每月24G傳輸量',
          '傳輸到量降速(最高下載速率12Mbps)',
          '網內前5分鐘免費',
          '網外30分鐘',
          '市話40分鐘'
        ] 
      },
      { 
        name: 'NT$ 799', 
        price: 'NT$ 799', 
        features: [
          '每月36G傳輸量',
          '傳輸到量降速(最高下載速率21Mbps)',
          '網內前10分鐘免費',
          '網外45分鐘',
          '市話60分鐘'
        ],
        popular: true 
      },
      { 
        name: 'NT$ 999', 
        price: 'NT$ 999', 
        features: [
          '每月60G傳輸量',
          '傳輸到量降速(最高下載速率50Mbps)',
          '網內免費',
          '網外60分鐘',
          '市話75分鐘'
        ] 
      },
      { 
        name: 'NT$ 1399', 
        price: 'NT$ 1399', 
        features: [
          '傳輸量吃到飽',
          '熱點分享50G',
          '網內免費',
          '網外110分鐘',
          '市話140分鐘'
        ] 
      }
    ],
    '台灣大哥大': [
      { 
        name: 'NT$ 599', 
        price: 'NT$ 599', 
        features: [
          '每月24G傳輸量',
          '傳輸到量降速(最高下載速率12Mbps)',
          '網內免費',
          '網外60分鐘'
        ] 
      },
      { 
        name: 'NT$ 799', 
        price: 'NT$ 799', 
        features: [
          '每月36G傳輸量',
          '傳輸到量降速(最高下載速率21Mbps)',
          '網內免費',
          '網外60分鐘'
        ],
        popular: true 
      },
      { 
        name: 'NT$ 999', 
        price: 'NT$ 999', 
        features: [
          '每月60G傳輸量',
          '傳輸到量降速(最高下載速率50Mbps)',
          '網內免費',
          '網外90分鐘'
        ] 
      },
      { 
        name: 'NT$ 1399', 
        price: 'NT$ 1399', 
        features: [
          '傳輸量吃到飽',
          '熱點分享50G',
          '網內免費',
          '網外220分鐘'
        ] 
      }
    ],
    '遠傳電信': [
      { 
        name: 'NT$ 599', 
        price: 'NT$ 599', 
        features: [
          '每月24G傳輸量',
          '傳輸到量降速(最高下載速率12Mbps)',
          '網內免費',
          '網外60分鐘'
        ] 
      },
      { 
        name: 'NT$ 799', 
        price: 'NT$ 799', 
        features: [
          '每月36G傳輸量',
          '傳輸到量降速(最高下載速率21Mbps)',
          '網內免費',
          '網外60分鐘'
        ],
        popular: true 
      },
      { 
        name: 'NT$ 999', 
        price: 'NT$ 999', 
        features: [
          '每月60G傳輸量',
          '傳輸到量降速(最高下載速率50Mbps)',
          '網內免費',
          '網外90分鐘'
        ] 
      },
      { 
        name: 'NT$ 1399', 
        price: 'NT$ 1399', 
        features: [
          '傳輸量吃到飽',
          '熱點分享50G',
          '網內免費',
          '網外220分鐘'
        ] 
      }
    ]
  };

  return (
    <section id="plans" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            門號與資費方案
          </h2>
          <p className="text-lg text-gray-600">
            比較各大電信業者方案，找到最適合您的選擇
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-gray-100 rounded-full p-1">
            {carriers.map((carrier) => (
              <button
                key={carrier}
                onClick={() => setSelectedCarrier(carrier)}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCarrier === carrier
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {carrier}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {plans[selectedCarrier as keyof typeof plans].map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 cursor-pointer ${
                plan.popular ? 'border-2 border-teal-600 shadow-xl' : 'border border-gray-200'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap">
                    最受歡迎
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <span className="text-3xl font-bold text-gray-900">{plan.price}</span>
                <span className="text-gray-600">/月</span>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`w-full py-3.5 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                plan.popular
                  ? 'bg-teal-600 text-white hover:bg-teal-700'
                  : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
              }`}>
                立即申辦
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
